import type { CartesianGridProps } from 'recharts';

const EDGE_EPSILON = 0.5;

// Keep only grid lines strictly inside the plot area, dropping the ones that
// land on the boundary (first/last tick).
const trimGridEdges = (coords: number[], min: number, max: number): number[] =>
  coords.filter(c => c > min + EDGE_EPSILON && c < max - EDGE_EPSILON);

type GridLineGenerators = Pick<
  CartesianGridProps,
  'horizontalCoordinatesGenerator' | 'verticalCoordinatesGenerator'
>;

// Returns the CartesianGrid coordinate generators that draw grid lines only on
// the interior tick positions (no lines on the chart border). Spread the result
// straight onto <CartesianGrid />.
export function interiorGridLines(xTicks: number[]): GridLineGenerators {
  return {
    verticalCoordinatesGenerator: ({ xAxis, offset }) =>
      trimGridEdges(
        xTicks.map(t => xAxis.scale(t)),
        offset.left ?? 0,
        (offset.left ?? 0) + (offset.width ?? 0),
      ),
    horizontalCoordinatesGenerator: ({ yAxis, offset }) => {
      const ticks: number[] =
        yAxis.niceTicks ?? yAxis.ticks ?? yAxis.scale.ticks?.() ?? [];
      return trimGridEdges(
        ticks.map(t => yAxis.scale(t)),
        offset.top ?? 0,
        (offset.top ?? 0) + (offset.height ?? 0),
      );
    },
  };
}
